/**
 * Files a content page was given before it turned into the app (src/intake).
 * The home screen takes them once, exactly as if they had been dropped on it,
 * so the page's link decides what happens to them (`?target=20mb`, `?for=…`).
 */
let handed: File[] = [];

export function handFiles(files: readonly File[]): void {
  handed = [...files];
}

/** The handed files, once: a second call (React's strict mode runs effects twice) gets none. */
export function takeHandedFiles(): File[] {
  const files = handed;
  handed = [];
  return files;
}
